var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-upload',{attrs:{"data":_vm.value,"needValid":true,"fileSize":_vm.config.rules.fileConfig.size,"fileType":_vm.config.rules.fileConfig.type,"limit":_vm.config.rules.fileConfig.limit,"disable":_vm.disable},on:{"update:data":function($event){_vm.value=$event},"fileValid":_vm.fileValid}})
}
var staticRenderFns = []

export { render, staticRenderFns }